module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon8.png?b146d701";